const lang_en = {
    "index01": "RWA-ART是一个集古董发射台、IDO、古董交割的综合性创新平台",
    "index011": "RWA-ART是一个集古董发射台、",
    "index012": "IDO、古董交割的综合性创新平台",
    "index02": "通过 RWA平台，你可以将你的古董资产代币化或者使用代币来交割古董",
    "index03": "estimate",
    "index04": "start",
    "index05": "end",
    "index06": "当前价格",
    "index07": "评估价",
    "index08": "进行中",
    "index09": "待开始",
    "index10": "已结束",
    "index11": "Partners providing technical support",
    "index12": "Launched",
    "index13": "Build a comprehensive RWA art tokenization platform on BSC enabling collectors to mint tokens and investors to trade.",



    "toastShowType01": "Confirm transaction in wallet...",
    "toastShowType02": "Transaction submitted.",
    "toastShowType03": "Operation Successful!",
    "toastShowType04": "Ineligible!",
    "toastShowType05": "Operation Canceled.",
    "view": "View",
    "account": "Account",
    "change": "Change",
    "disconnect": "Disconnect",
    "caddr": "Copy Address",
    "viewbro": "View in Browser",
    "connected": "Connected",
    "conwall": "Connect Wallet",
    "gmai": "Buy",
    "gmcg": "Purchase successful",
    "gmsb": "Purchase failed",
    "jgcg": "Delivery successful",
    "jgsb": "Delivery failed",
    "home": "Home",
    "wkuang": "Mining",
    "scheng": "Stores",
    "dbjj": "Tokenomics",
    "wdkk": "My NFT",
    "xlt": "Roadmap",
    "tgjj": "Promotion rewards",
    "xliang": "Limited quantity",
    "syu": "Remaining",
    "jge": "Price",
    "sl": "Margin",
    "fe": "Units",
    "bpishu": "WhitePaper",
    "bhao": "Number",
    "zrang": "Transfer",
    "jsdz": "Receiving Address",
    "qux": "Cancel",
    "qrzr": "Confirm transfer",
    "tgjl": "Promotion reward",
    "wdjl": "My reward",
    "wdjlze": "My total reward amount",
    "wdyqlj": "My invitation link",
    "qxljqb": "Please connect your wallet first!",
    "yqjl": "Invitation Record",
    "zyqs": "Total number of invitations",
    "xuhao": "Number",
    "dizi": "Address",
    "jlje": "Reward amount",
    "sjian": "Time",
    "jzz": "Loading...",
    "zwsj": "No data!",
    "fzcg": "Copy successful!",
    "myfzrhnr": "No content was copied!",
    "jqqd": "Coming soon!",
    "sqsb": "Authorization failed!",
    "wlljcw": "Network Connection Error!",
    "qsrzcdjsdz": "Please enter the correct receiving address!",
    "ystxz": "OG PASS",
    "bqsy": "Copyright © 2025 RWA.ART, Inc. - All Rights Reserved.",
    "yqpybzqyj": "Invite friends to earn commissions!",
    "pro1": "Up to ",
    "pro2": "10%",
    "pro3": " rebate!",
    "mchygmkj": "Every time a friend purchases a mining machine, you will receive a reward.",
    "gmbuc": "Buy BUCOIN",
}
export default lang_en;
